import { render, staticRenderFns } from "./SolicitaAtencionView.vue?vue&type=template&id=176e4160"
import script from "./SolicitaAtencionView.vue?vue&type=script&lang=ts"
export * from "./SolicitaAtencionView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports